"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var unmask_1 = require("../utils/unmask");
var isValid = function (value) {
    var cleanValue = (0, unmask_1.unmask)(value);
    if (cleanValue.length !== 8)
        return false;
    var regex = /^([\d]{2})\.?([\d]{3})-?([\d]{3})/;
    return regex.test(cleanValue);
};
var validateCep = function (value) {
    return isValid(value) ? false : 'CEP inválido';
};
exports.default = validateCep;
//# sourceMappingURL=cep.js.map